import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./css/Navbar.module.css";
import logo from "../assets/logo_mm.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../redux/slices/languageSlice";
import {
  Badge,
  Drawer,
  List,
  ListItem,
  ListItemText,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { setQuantity } from "../redux/slices/quantitySlice";
import { SelectChangeEvent } from "@mui/material/Select";

const NavbarMobile: FunctionComponent = () => {
  const language = useSelector((state: any) => state.language.value);
  const dispatch = useDispatch();
  const location = useLocation();

  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("accessToken");
  const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
  const [totalQuantity, setTotalQuantity] = useState(
    cartItems.reduce(
      (acc: number, item: { quantity: number }) => acc + item.quantity,
      0
    )
  );

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    dispatch(setQuantity(totalQuantity));
  }, [totalQuantity]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    console.log(window.scrollY);

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleProfileClick = () => {
    if (isLoggedIn) {
      navigate("/admin/myaccount");
    } else {
      navigate("/login");
    }
  };

  const toggleDrawer = (open: boolean) => () => {
    setIsDrawerOpen(open);
  };

  return (
    <Box
      sx={{
        position: isFixed ? "fixed" : "relative",
        top: isFixed ? 0 : "auto",
        left: 0,
        zIndex: 100,
        width: "100%",
        background: "#FCFCF2",
        borderBottom: "1px solid #c4b67c",
        transition: "position 0.3s ease-in-out",
      }}
    >
      <AppBar
        position="static"
        style={{
          background: "transparent",
          boxShadow: "unset",
        }}
      >
        <Toolbar className={styles.appBar}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2, color: "black", marginRight: 0 }}
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
          <Link to="/" className={styles.logo}>
            <img className={styles.logoText} src={logo} alt="Logo" />
          </Link>
          <div className={styles.frame}>
            <div className={styles.cart}>
              <Badge badgeContent={totalQuantity} color="primary">
                <ShoppingBagOutlinedIcon
                  onClick={() => navigate("/cart")}
                  style={{ color: "#517159" }}
                />
              </Badge>
              <PersonOutlineOutlinedIcon
                style={{ color: "#517159" }}
                onClick={handleProfileClick}
              />
            </div>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <Box
          style={{ background: "#517059" }}
          sx={{
            width: "90vw",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            padding: "20px",
          }}
          role="presentation"
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <FormControl sx={{ width: "fit-content", padding: "0px" }}>
              <Select
                sx={{
                  color: "white",
                  "& .MuiSelect-icon": {
                    color: "#C4B57C",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  fontSize: "18px",
                }}
                value={language}
                onChange={(event: SelectChangeEvent) => {
                  dispatch(setLanguage(event.target.value));
                }}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem sx={{ color: "#517059" }} value={"RO"}>
                  RO
                </MenuItem>
                <MenuItem sx={{ color: "#517059" }} value={"EN"}>
                  EN
                </MenuItem>
              </Select>
            </FormControl>
            <IconButton
              onClick={toggleDrawer(false)}
              sx={{
                color: "#C4B57C",
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>

          <List
            sx={{
              marginTop: "30px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <ListItem
              style={{ textAlign: "center" }}
              onClick={() => {
                navigate("/");
                setIsDrawerOpen(false);
              }}
            >
              <ListItemText
                primary={
                  <span
                    style={{
                      color: "white",
                      fontSize: "18px",
                    }}
                  >
                    {language === "EN" && "Home"}
                    {language === "RO" && "Acasă"}
                  </span>
                }
              />
            </ListItem>

            <ListItem
              style={{ textAlign: "center" }}
              onClick={() => {
                navigate("/about");
                setIsDrawerOpen(false);
              }}
            >
              <ListItemText
                primary={
                  <span
                    style={{
                      color: "white",
                      fontSize: "18px",
                    }}
                  >
                    {language === "EN" && "About the author"}
                    {language === "RO" && "Despre autoare"}
                    {language === "RU" && "Об авторе"}
                  </span>
                }
              />
            </ListItem>
            <ListItem
              style={{ textAlign: "center" }}
              onClick={() => {
                location.pathname === "/consultation"
                  ? scrollToSection("section8")
                  : navigate("/consultation");
                setIsDrawerOpen(false);
              }}
            >
              <ListItemText
                primary={
                  <span
                    style={{
                      color: "white",
                      fontSize: "18px",
                    }}
                  >
                    {language === "EN" && "1:1 Consultation"}
                    {language === "RO" && "Consultație 1:1"}
                    {language === "RU" && "Консультация"}
                  </span>
                }
              />
            </ListItem>
            <ListItem
              style={{ textAlign: "center" }}
              onClick={() => {
                navigate("/contacts");
                setIsDrawerOpen(false);
              }}
            >
              <ListItemText
                primary={
                  <span
                    style={{
                      color: "white",
                      fontSize: "18px",
                    }}
                  >
                    {language === "EN" && "Contacts"}
                    {language === "RO" && "Contacte"}
                    {language === "RU" && "Контакты"}
                  </span>
                }
              />
            </ListItem>
            <ListItem
              style={{ justifyContent: "center" }}
              onClick={() => {
                navigate("/cart");
                setIsDrawerOpen(false);
              }}
            >
              <ListItemText
                primary={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "15px",
                    }}
                  >
                    <Badge
                      badgeContent={totalQuantity}
                      color="primary"
                      sx={{
                        "& .MuiBadge-badge": {
                          backgroundColor: "#C4B57C",
                          color: "white",
                        },
                      }}
                    >
                      <svg
                        width="22"
                        height="24"
                        viewBox="0 0 22 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M15.4656 7.55857C15.4656 8.13067 14.8148 8.59729 14.1549 8.59729C13.5041 8.59729 12.9575 8.13067 12.9575 7.55857V6.89509C12.9575 6.33003 13.5041 5.85457 14.1549 5.85457C14.8148 5.85457 15.4656 6.33003 15.4656 6.89509V7.55857ZM9.14677 7.55857C9.14677 8.13067 8.60019 8.59729 7.83703 8.59729C7.18622 8.59729 6.63968 8.13067 6.63968 7.55857V6.89509C6.63968 6.33003 7.18622 5.85457 7.83703 5.85457C8.60019 5.85457 9.14677 6.33003 9.14677 6.89509V7.55857ZM22 23.0509L20.8026 5.67443C20.6893 5.19988 20.2642 4.81494 19.8138 4.81494H2.28239C1.73583 4.81494 1.30971 5.19988 1.30971 5.67443L0 23.0509C0 23.3374 0.10424 23.5184 0.216588 23.7144C0.434199 23.9025 0.650819 24 0.971669 24H21.1326C21.5668 24 22 23.616 22 23.1484C22 23.0509 22 23.0509 22 23.0509ZM10.9959 1.70314C12.5233 1.70314 13.7206 2.74275 13.7206 4.06183H15.6822C15.6822 1.80068 13.6164 0 10.9959 0C8.49695 0 6.3178 1.80068 6.3178 4.06183H8.27935C8.27935 2.74275 9.47671 1.70314 10.9959 1.70314Z"
                          fill="white"
                        />
                      </svg>
                    </Badge>
                    <span style={{ color: "white", fontSize: "18px" }}>
                      {language === "EN" ? "Cart" : "Coș"} ({totalQuantity})
                    </span>
                  </div>
                }
              />
            </ListItem>

            <ListItem
              style={{ justifyContent: "center", textAlign: "center" }}
              onClick={() => {
                navigate(isLoggedIn ? "/admin/myaccount" : "/login");
                setIsDrawerOpen(false);
              }}
            >
              <ListItemText
                primary={
                  <span style={{ color: "white", fontSize: "18px" }}>
                    {isLoggedIn
                      ? language === "RO"
                        ? "Cont personal"
                        : "My Account"
                      : language === "EN"
                      ? "Login"
                      : language === "RO"
                      ? "Autentificare"
                      : "Войти"}
                  </span>
                }
              />
            </ListItem>
          </List>

          <div
            style={{
              width: "100%",
              height: "1px",
              backgroundColor: "#C4B57C",
              margin: "20px 0",
            }}
          />

          <div
            style={{
              color: "white",
              fontSize: "16px",
              padding: "0 20px",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              gap: "20px",
            }}
          >
            <div>info@marianamelnic.com</div>
            <div
              style={{
                display: "flex",
                gap: "20px",
                justifyContent: "center",
              }}
            >
              <a
                href="https://www.instagram.com/mariana_melnic_"
                target="_blank"
                style={{ color: "#C4B57C", textDecoration: "none" }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C9.555 3 9.25125 3.01125 8.28975 3.054C7.33125 3.09675 6.67425 3.24675 6.105 3.4725C5.51625 3.70575 5.0115 4.01775 4.51125 4.51125C4.017 5.0115 3.705 5.51625 3.4725 6.105C3.24675 6.67425 3.09675 7.33125 3.054 8.28975C3.01125 9.25125 3 9.555 3 12C3 14.445 3.01125 14.7488 3.054 15.7103C3.09675 16.6687 3.24675 17.3258 3.4725 17.895C3.70575 18.4837 4.01775 18.9885 4.51125 19.4887C5.0115 19.983 5.51625 20.2942 6.105 20.5275C6.67425 20.7532 7.33125 20.9032 8.28975 20.946C9.25125 20.9887 9.555 21 12 21C14.445 21 14.7488 20.9887 15.7103 20.946C16.6687 20.9032 17.3258 20.7532 17.895 20.5275C18.4837 20.2942 18.9885 19.983 19.4887 19.4887C19.983 18.9885 20.2942 18.4837 20.5275 17.895C20.7532 17.3258 20.9032 16.6687 20.946 15.7103C20.9887 14.7488 21 14.445 21 12C21 9.555 20.9887 9.25125 20.946 8.28975C20.9032 7.33125 20.7532 6.67425 20.5275 6.105C20.2942 5.51625 19.983 5.0115 19.4887 4.51125C18.9885 4.017 18.4837 3.705 17.895 3.4725C17.3258 3.24675 16.6687 3.09675 15.7103 3.054C14.7488 3.01125 14.445 3 12 3ZM12 4.62375C14.4037 4.62375 14.6888 4.63425 15.6412 4.677C16.5172 4.71675 16.9987 4.86075 17.3212 4.98375C17.7037 5.145 18.0037 5.34225 18.3187 5.6565C18.6337 5.97225 18.8302 6.27225 18.9915 6.65475C19.1145 6.97725 19.2585 7.458 19.2982 8.334C19.341 9.28725 19.3515 9.57225 19.3515 11.976C19.3515 14.3797 19.341 14.6648 19.2982 15.618C19.2585 16.494 19.1145 16.9755 18.9915 17.2972C18.8302 17.6797 18.6337 17.9797 18.3187 18.2955C18.0037 18.6105 17.7037 18.807 17.3212 18.9682C16.9987 19.0912 16.5172 19.2352 15.6412 19.275C14.6888 19.3177 14.4037 19.3282 12 19.3282C9.59625 19.3282 9.31125 19.3177 8.359 19.275C7.483 19.2352 7.0015 19.0912 6.67875 18.9682C6.29625 18.807 5.99625 18.6105 5.68125 18.2955C5.36625 17.9797 5.16975 17.6797 5.0085 17.2972C4.8855 16.9755 4.7415 16.494 4.70175 15.618C4.659 14.6648 4.64925 14.3797 4.64925 11.976C4.64925 9.57225 4.659 9.28725 4.70175 8.334C4.7415 7.458 4.8855 6.97725 5.0085 6.65475C5.16975 6.27225 5.36625 5.97225 5.68125 5.6565C5.99625 5.34225 6.29625 5.145 6.67875 4.98375C7.0015 4.86075 7.483 4.71675 8.359 4.677C9.31125 4.63425 9.59625 4.62375 12 4.62375ZM12 7.37625C9.44775 7.37625 7.37625 9.44775 7.37625 12C7.37625 14.5522 9.44775 16.6238 12 16.6238C14.5522 16.6238 16.6238 14.5522 16.6238 12C16.6238 9.44775 14.5522 7.37625 12 7.37625ZM12 15C10.3432 15 9 13.6567 9 12C9 10.3432 10.3432 9 12 9C13.6567 9 15 10.3432 15 12C15 13.6567 13.6567 15 12 15ZM17.8837 7.196C17.8837 7.79824 17.3952 8.28674 16.793 8.28674C16.1907 8.28674 15.7022 7.79824 15.7022 7.196C15.7022 6.59375 16.1907 6.10525 16.793 6.10525C17.3952 6.10525 17.8837 6.59375 17.8837 7.196Z"
                    fill="#C4B57C"
                  />
                </svg>
              </a>
              <a
                href="https://t.me/marianamelnic"
                target="_blank"
                style={{ color: "#C4B57C", textDecoration: "none" }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.64 8.8C16.49 10.38 15.84 14.22 15.51 16.01C15.37 16.77 15.09 17.01 14.83 17.04C14.25 17.11 13.81 16.68 13.25 16.32C12.37 15.73 11.87 15.35 11.02 14.78C10.03 14.12 10.67 13.76 11.24 13.18C11.39 13.03 13.95 10.7 14 10.49C14.0069 10.4582 14.006 10.4252 13.9973 10.3938C13.9886 10.3624 13.9724 10.3337 13.95 10.31C13.89 10.26 13.81 10.28 13.74 10.29C13.65 10.31 12.25 11.24 9.52 13.08C9.12 13.35 8.76 13.49 8.44 13.48C8.08 13.47 7.4 13.28 6.89 13.11C6.26 12.91 5.77 12.8 5.81 12.45C5.83 12.27 6.08 12.09 6.55 11.9C9.47 10.63 11.41 9.79 12.38 9.39C15.16 8.23 15.73 8.03 16.11 8.03C16.19 8.03 16.38 8.05 16.5 8.15C16.6 8.23 16.63 8.34 16.64 8.42C16.63 8.48 16.65 8.66 16.64 8.8Z"
                    fill="#C4B57C"
                  />
                </svg>
              </a>
            </div>
          </div>

          <div style={{ marginTop: "auto" }} />
        </Box>
      </Drawer>
    </Box>
  );
};

export default NavbarMobile;
